import { QueryClient } from '@tanstack/vue-query';
import { type AxiosError, HttpStatusCode, isAxiosError } from 'axios';

declare module '@tanstack/vue-query' {
  interface Register {
    defaultError: AxiosError
  }
}

const nonRetriableCodes: HttpStatusCode[] = [
  HttpStatusCode.Forbidden,
  HttpStatusCode.NotFound,
];

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60, // 1 minute
      retry: (failureCount, error) => {
        if (
          isAxiosError(error)
          && error.response?.status
          && nonRetriableCodes.includes(error.response.status)
        ) {
          return false;
        }

        return failureCount < 3;
      },
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
  },
});
